<!-- Sidemenu -->
<div class="main-sidebar main-sidebar-sticky side-menu">
    <div class="sidemenu-logo" style="background-color: #8743c7;">
        <a class="main-logo" routerLink="/dashboard">
            <img src="../../assets/img/brand/logo-white.png" class="header-brand-img desktop-logo" alt="logo"
                style="width: 70px;">
            <!-- <img src="../../assets/img/brand/icon-light.png" class="header-brand-img icon-logo" alt="logo"> -->
            <!-- <img src="../../assets/img/brand/logo.png" class="header-brand-img desktop-logo theme-logo" alt="logo"> -->
            <img src="../../assets/img/brand/icon-white.png" class="header-brand-img icon-logo" alt="logo" style="width: 45px;">
            <!-- <h1 class="header-brand-logo mb-5" style="color: #fff; font-size: 1.5rem;">
                &#10100; App Blender &#10101;</h1> -->
        </a>
    </div>

    <div class="main-sidebar-body">
        <!-- <div class="nav-toggler d-flex justify-content-evenly w-100" *ngIf="isAdmin">
            <a class="btn ripple text-white btn-icon w-50  text-center" (click)="navMenu_selected = 0" [ngClass]="{'btn-primary': navMenu_selected == 0, 'btn-dark': navMenu_selected == 1}">
                <i class=" fe fe-user me-2"></i>
            </a>
            <a class="btn ripple text-white btn-icon w-50 text-center" (click)="navMenu_selected = 1" [ngClass]="{'btn-primary': navMenu_selected == 1, 'btn-dark': navMenu_selected == 0}">
                <i class=" fe fe-settings me-2"></i>
            </a>
        </div> -->
        <ul class="nav mt-1" *ngIf="navMenu_selected == 0">
            <!-- 1st Level Menu -->
            <li class="nav-item" *ngFor="let menuItem of menuItems"
                [ngClass]="{active: menuItem.active, 'show': menuItem.active}">
                <div class="nav-header d-flex align-items-baseline" *ngIf=" menuItem.headTitle">
                    <span class="nav-label">{{menuItem.headTitle}}</span>
                    <span class="nav-label nav-label-icon-space ti ti-plus"
                        *ngIf="menuItem.action == 'createPool'"
                        (click)="displayModal(menuItem)"></span>
                </div>
                <!-- has-Link -->
                <a class="nav-link" [routerLink]="!menuItem.type ? null : [menuItem.path]" routerLinkActive="active"
                    *ngIf="menuItem.type === 'link' && canShowMenuItem(menuItem)" (click)="toggleNavActive(menuItem)">
                    <span class="shape1"></span>
                    <span class="shape2"></span>
                    <i *ngIf="menuItem.icon" class="{{menuItem.icon}} sidemenu-icon"></i>
                    <span class="sidemenu-label">{{menuItem.title}}</span>
                </a>
                <a class="nav-link" routerLinkActive="active" *ngIf="menuItem.type === 'modal' && canShowMenuItem(menuItem)"
                    (click)="displayModal(menuItem)">
                    <span class="shape1"></span>
                    <span class="shape2"></span>
                    <i *ngIf="menuItem.icon" class="{{menuItem.icon}} sidemenu-icon"></i>
                    <span class="sidemenu-label">{{menuItem.title}}</span>
                </a>
                <!-- has-Sub -->
                <a class="nav-link with-sub" [routerLink]="menuItem.type ? null: [menuItem.path]"
                    *ngIf="menuItem.type === 'sub' && canShowMenuItem(menuItem)" (click)="toggleNavActive(menuItem)">
                    <span class="shape1"></span>
                    <span class="shape2"></span>
                    <i *ngIf="menuItem.icon" class="{{menuItem.icon}} sidemenu-icon"></i>
                    <span class="sidemenu-label">{{menuItem.title}}</span>
                    <span class="badge {{menuItem.badgeClass}} side-badge"
                        *ngIf="menuItem.badgeClass && menuItem.badgeValue">
                        {{menuItem.badgeValue}}
                    </span>
                    <i class="angle fe fe-chevron-right" [ngClass]="{ 'd-none': menuItem.badgeClass}"></i>

                </a>


                <!-- 2nd Level menu -->
                <ul class="nav-sub" *ngIf="menuItem.children">
                    <li class="nav-sub-item" *ngFor="let childrenItem of menuItem.children"
                        [ngClass]="{'show': childrenItem?.active}">

                        <!-- link -->
                        <a class="nav-sub-link" [routerLink]="!childrenItem.type ? null : [childrenItem.path] "
                            routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                            *ngIf="childrenItem?.type === 'link' " (click)="toggleNavActive(childrenItem)">
                            {{childrenItem.title}}
                        </a>

                        <!-- sub -->
                        <a class="nav-sub-link with-sub1" [routerLink]="childrenItem.type ? null : [childrenItem.path]"
                            *ngIf="childrenItem?.type === 'sub' " (click)="toggleNavActive(childrenItem)">
                            {{childrenItem.title}}
                            <i class="angle fe fe-chevron-right"></i>
                        </a>

                        <!-- 3rd Level menu -->
                        <ul class="nav-sub1" *ngIf="childrenItem?.children">
                            <li class="nav-sub-item1" *ngFor="let childrenSubItem of childrenItem.children"
                                [ngClass]="{'show': childrenSubItem.active}">
                                <!-- link -->
                                <a class="nav-sub-link"
                                    [routerLink]="!childrenSubItem.type ?  [childrenSubItem.path] : null"
                                    *ngIf="childrenSubItem.type === 'link'" routerLinkActiveOptions="{exact : true}">
                                    {{childrenSubItem.title}}
                                </a>
                                <!-- sub -->
                                <a class="nav-sub-link with-sub2"
                                    [routerLink]="childrenSubItem.type ? null : [childrenSubItem.path]"
                                    *ngIf="childrenSubItem.type === 'sub' " (click)="toggleNavActive(childrenSubItem)">
                                    {{childrenSubItem.title}}
                                    <i class="angle fe fe-chevron-right"></i>
                                </a>

                                <!--4th level -->
                                <ul class="nav-sub2" *ngIf="childrenSubItem.children">
                                    <li class="nav-sub-item2" *ngFor="let childrenSubItem1 of childrenSubItem.children"
                                        [ngClass]="{'show': childrenSubItem1.active}">
                                        <a class="nav-sub-link"
                                            [routerLink]="!childrenSubItem1.type ? [childrenSubItem1.path] : null "
                                            *ngIf="childrenSubItem1.type === 'link'">
                                            {{childrenSubItem1.title}}</a>
                                    </li>
                                </ul>

                            </li>
                        </ul>

                    </li>
                </ul>
            </li>

        </ul>
<!-- Admin nav
        <ul class="nav" *ngIf="navMenu_selected == 1">
            1st Level Menu
            <li class="nav-item" *ngFor="let menuItem of adminMenuItems"
                [ngClass]="{active: menuItem.active && navMenu_selected == 1, 'show': menuItem.active}">
                <div class="nav-header" *ngIf="menuItem.headTitle">
                    <span class="nav-label">{{menuItem.headTitle}}</span>
                </div>
                has-Link
                <a class="nav-link" [routerLink]="!menuItem.type ? null : [menuItem.path]" routerLinkActive="active"
                    *ngIf="menuItem.type === 'link' " (click)="toggleNavActive(menuItem)">
                    <span class="shape1"></span>
                    <span class="shape2"></span>
                    <i *ngIf="menuItem.icon" class="{{menuItem.icon}} sidemenu-icon"></i>
                    <span class="sidemenu-label">{{menuItem.title}}</span>
                </a>
                <a class="nav-link" routerLinkActive="active" *ngIf="menuItem.type === 'modal' "
                    (click)="displayModal(menuItem)">
                    <span class="shape1"></span>
                    <span class="shape2"></span>
                    <i *ngIf="menuItem.icon" class="{{menuItem.icon}} sidemenu-icon"></i>
                    <span class="sidemenu-label">{{menuItem.title}}</span>
                </a>
                has-Sub
                <a class="nav-link with-sub" [routerLink]="menuItem.type ? null: [menuItem.path]"
                    *ngIf="menuItem.type === 'sub'" (click)="toggleNavActive(menuItem)">
                    <span class="shape1"></span>
                    <span class="shape2"></span>
                    <i *ngIf="menuItem.icon" class="{{menuItem.icon}} sidemenu-icon"></i>
                    <span class="sidemenu-label">{{menuItem.title}}</span>
                    <span class="badge {{menuItem.badgeClass}} side-badge"
                        *ngIf="menuItem.badgeClass && menuItem.badgeValue">
                        {{menuItem.badgeValue}}
                    </span>
                    <i class="angle fe fe-chevron-right" [ngClass]="{ 'd-none': menuItem.badgeClass}"></i>

                </a>

                2nd Level menu
                <ul class="nav-sub" *ngIf="menuItem.children">
                    <li class="nav-sub-item" *ngFor="let childrenItem of menuItem.children"
                        [ngClass]="{'show': childrenItem?.active}">

                        link
                        <a class="nav-sub-link" [routerLink]="!childrenItem.type ? null : [childrenItem.path] "
                            routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                            *ngIf="childrenItem?.type === 'link' " (click)="toggleNavActive(childrenItem)">
                            {{childrenItem.title}}
                        </a>

                        sub
                        <a class="nav-sub-link with-sub1" [routerLink]="childrenItem.type ? null : [childrenItem.path]"
                            *ngIf="childrenItem?.type === 'sub' " (click)="toggleNavActive(childrenItem)">
                            {{childrenItem.title}}
                            <i class="angle fe fe-chevron-right"></i>
                        </a>

                        3rd Level menu
                        <ul class="nav-sub1" *ngIf="childrenItem?.children">
                            <li class="nav-sub-item1" *ngFor="let childrenSubItem of childrenItem.children"
                                [ngClass]="{'show': childrenSubItem.active}">
                                link
                                <a class="nav-sub-link"
                                    [routerLink]="!childrenSubItem.type ?  [childrenSubItem.path] : null"
                                    *ngIf="childrenSubItem.type === 'link'" routerLinkActiveOptions="{exact : true}">
                                    {{childrenSubItem.title}}
                                </a>
                                sub
                                <a class="nav-sub-link with-sub2"
                                    [routerLink]="childrenSubItem.type ? null : [childrenSubItem.path]"
                                    *ngIf="childrenSubItem.type === 'sub' " (click)="toggleNavActive(childrenSubItem)">
                                    {{childrenSubItem.title}}
                                    <i class="angle fe fe-chevron-right"></i>
                                </a>

                                4th level
                                <ul class="nav-sub2" *ngIf="childrenSubItem.children">
                                    <li class="nav-sub-item2" *ngFor="let childrenSubItem1 of childrenSubItem.children"
                                        [ngClass]="{'show': childrenSubItem1.active}">
                                        <a class="nav-sub-link"
                                            [routerLink]="!childrenSubItem1.type ? [childrenSubItem1.path] : null "
                                            *ngIf="childrenSubItem1.type === 'link'">
                                            {{childrenSubItem1.title}}</a>
                                    </li>
                                </ul>

                            </li>
                        </ul>

                    </li>
                </ul>
            </li>

        </ul> -->


    </div>
</div>
<!-- End Sidemenu -->




<!-- Modals -->


<!--Create Pool-->
<!-- <ng-template #createPool let-modal>
    LARGE MODAL
    <div class="modal-header">
        <h6 class="modal-title" id="modal-basic-title">Add new pool</h6>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <app-create-pool></app-create-pool>
</ng-template> -->